import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 text-gray-400 py-8 border-t border-navy-800 text-center" data-id="element-142">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <p className="font-heading text-lg text-gold mb-2 font-bold" data-id="element-144">
          Biblia Visual
        </p>
        <p className="mb-1 text-sm" data-id="element-145">
          © Biblia Visual — Todos Los Derechos Reservados
        </p>
        <p className="text-xs" data-id="element-146">
          Producto digital con acceso inmediato tras el pago.
        </p>
      </div>
    </footer>;
}